(ns common.spec
  (:require ["react" :as react]
            [clojure.spec.alpha :as spec]))

(spec/def :datascript/entity-id
  (spec/or :pos-int pos-int?
           :vector (spec/tuple keyword? any?)))

(spec/def :react/element
  (spec/nilable (some-fn vector? string? number? fn? react/isValidElement)))

(spec/def :string/not-empty
  (spec/and string? not-empty))

(spec/def :reframe/sub-or-event-id
  (spec/or :keyword keyword?
           :string :string/not-empty))

(spec/def :reframe/sub-or-event
  (spec/cat :id :reframe/sub-or-event-id
            :args (spec/* any?)))

(defn eid? [eid]
  (spec/valid? :datascript/entity-id eid))
